export const tenantMgmtTypes = {
    GET_ALL_TENANTS: 'GET_ALL_TENANTS',
    GET_ALL_TENANTS_SUCCESS: 'GET_ALL_TENANTS_SUCCESS',
    GET_ALL_TENANTS_FAILURE: 'GET_ALL_TENANTS_FAILURE',
}